app.component('hrefButton', {
    template: '<div layout="row" layout-align="end center" style="width:100%;">'+
              '<md-button ng-click="$ctrl.changeLocation()" layout="row">'+
              '<span>{{$ctrl.title}}</span>'+
              '<md-icon md-svg-src="app/common/svg/ic_arrow_forward_black_24px.svg"></md-icon>'+
              '</md-button>',
    controller: function ($location, $window) {
        var $ctrl = this;
        $ctrl.changeLocation = function() {
            if( $ctrl.link == "0" ) {
                $location.path($ctrl.locationPath);
            }
            else {
                $window.open($ctrl.locationPath);
            }            
        }
    },
    bindings: {
        title : '@',
        locationPath : '@',
        link : '@'
    }
});
